import { environment } from '@environment';

export interface MajorPartner {
  id: string;
  logo: string;
  url: string;
  size: {
    width: number;
    height: number;
  };
}

const logoSrc = `${environment.wizbiiImages}/partenaires/logos`;

export const MAJOR_PARTNERS: MajorPartner[] = [
  {
    id: 'Pole Emploi',
    logo: `${logoSrc}/pole-emploi.png`,
    url: 'https://www.pole-emploi.fr/accueil/',
    size: {
      width: 120,
      height: 96,
    },
  },
  {
    id: 'Mission Locale',
    logo: `${logoSrc}/mission-locale.png`,
    url: 'https://www.unml.info/',
    size: {
      width: 141,
      height: 69,
    },
  },

  {
    id: 'Casa',
    logo: `${logoSrc}/casa.png`,
    url: 'https://www.youzful-by-ca.fr/',
    size: {
      width: 145,
      height: 61,
    },
  },
  {
    id: 'wizbii',
    logo: `${logoSrc}/wizbii.png`,
    url: 'https://www.wizbii.com/',
    size: {
      width: 146,
      height: 39,
    },
  },
  {
    id: 'Mon Compte Formation',
    logo: `${logoSrc}/mon-compte-formation.png`,
    url: 'https://www.moncompteformation.gouv.fr',
    size: {
      width: 148,
      height: 98,
    },
  },
  {
    id: 'Beta.gouv',
    logo: `${logoSrc}/beta.png`,
    url: 'https://beta.gouv.fr/',
    size: {
      width: 151,
      height: 52,
    },
  },
];
